/**
 * ACORDE — Chips de filtro rápido y selector de intensidad.
 *
 * Cada chip es un enlace real (el que Shopify da para activar o quitar un valor de filtro).
 * Aquí se intercepta el toque y se le pide a los filtros de Horizon que apliquen esa URL sin
 * recargar (`updateFiltersByURL`): actualiza la dirección, vuelve a pintar la sección y, con ella,
 * los propios chips con su nuevo estado. Si algo falla, el enlace navega normalmente.
 */
document.addEventListener('click', (evento) => {
  if (evento.defaultPrevented || evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.button !== 0) return;
  if (!(evento.target instanceof Element)) return;

  const chip = evento.target.closest('a[data-acorde-filtro]');
  if (!chip) return;

  const filtros = document.querySelector('facets-form-component');
  if (!filtros || typeof filtros.updateFiltersByURL !== 'function') return;

  evento.preventDefault();
  chip.closest('.acorde-chips')?.setAttribute('aria-busy', 'true');

  try {
    const url = new URL(chip.href, location.origin);
    filtros.updateFiltersByURL(url.pathname + url.search);
  } catch {
    location.href = chip.href;
  }
});
